import type {
  TenantNotificationSettings,
  TenantNotificationSettingsUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const notificationsApi = {
  get() {
    return request<TenantNotificationSettings>("/admin/notifications/settings");
  },
  update(input: TenantNotificationSettingsUpdateInput) {
    return request<TenantNotificationSettings>(
      "/admin/notifications/settings",
      { method: "PATCH", body: input },
    );
  },
};
